module.exports = ".special-name {\n  width: 78% !important;\n  position: initial !important; }\n"